module.exports = __webpack_public_path__ + "static/media/Yomi_Adisa_art.4ead3d33.jpg";